module.exports = "/_next/static/images/cf7e5b69c6441104ca9a5d3ab6fa995c-nu-fifa-logo@3x.png";